export const STRIPE_PORTAL_LINK =
  "https://billing.stripe.com/p/login/7sI5km8a2fxreB2000";
